<template>
	<ui-modal-template>
		<template v-slot:title>
			<span v-if="saleIntention === null"
				>Fruchtart für Ernte {{ form.product__harvest }}</span
			>
			<span v-else
				>Vermarktungsmenge für Ernte {{ form.product__harvest }}</span
			>
		</template>
		<template v-slot:content>
			<form class="h-full flex flex-col">
				<div class="p-0">
					<div class="px-6 py-6">
						<p v-if="saleIntention === null">
							Fügen Sie hier eine Fruchtart hinzu und legen für diese Ihre
							geplante Verkaufsmenge in der Ernte
							{{ form.product__harvest }} fest!
						</p>
						<p v-else>
							Bearbeiten Sie hier die Vermarktungsmenge einer Fruchtart der
							Ernte {{ form.product__harvest }}.
						</p>
					</div>

					<hr class="h-0.5 bg-gray-200 text-gray-200" />

					<div class="flex flex-col md:flex-row px-6 gap-x-6">
						<ui-select-group
							class="basis-full sm:basis-[30.75%] py-4"
							v-model="form.product__type"
							field="product__type"
							type="select"
							label="Article"
							:options="productTypes"
							:form="form"
							:required="true"
							:placeholder="false"
							v-on:change="productTypeChanged"
						></ui-select-group>

						<ui-select-group
							class="basis-full sm:basis-[30.75%] py-4"
							v-model="form.product__grade"
							field="product__grade"
							type="select"
							label="Quality Grade"
							:options="currentProductGradeOptions"
							:form="form"
							:required="true"
							v-if="hasMultipleGrades"
							:placeholder="false"
						></ui-select-group>
					</div>

					<hr class="h-0.5 bg-gray-200 text-gray-200 my-2" />

					<div class="p-6 px-6">
						<h3 class="font-medium text-lg">Mengenerfassung</h3>

						<div class="flex sm:w-2/3 mt-4 text-lg gap-x-6">
							<ui-radio-group
								v-model="form.qty__entry_type"
								radioValue="amount"
								:key="form.qty__entry_type + 'amount'"
								name="qty__entry_type"
								field="qty__entry_type"
								v-on:change="qtyEntryTypeChanged"
							>{{ __("Mengeneingabe") }}</ui-radio-group
							>
							<ui-radio-group
								class="whitespace-nowrap"
								v-model="form.qty__entry_type"
								radioValue="calculated"
								:key="form.qty__entry_type + 'calculated'"
								name="qty__entry_type"
								field="qty__entry_type"
								v-on:change="qtyEntryTypeChanged"
							>{{ __("Fläche * Ertrag") }}</ui-radio-group
							>
						</div>
						<span class="mt-1 text-red-600 text-sm" v-if="errors.qty__entry_type">{{ errors.qty__entry_type[0] }}</span>
					</div>

					<div v-if="form.qty__entry_type === 'calculated'" class="flex px-6 gap-x-6">
						<ui-input-group
							class="basis-full sm:basis-[30.75%] py-4"
							v-model="form.hectare"
							field="hectare"
							:key="form.qty__entry_type + '-hectare'"
							label="Fläche"
							:form="form"
							:required="true"
							suffix="ha"
							tooltipText="Gesamte Anbaufläche auf der Sie das gewählte Ernteprodukt anbauen."
						></ui-input-group>

						<ui-input-group
							class="basis-full sm:basis-[30.75%] py-4"
							v-model="form.yield_per_hectare"
							field="yield_per_hectare"
							:key="form.qty__entry_type + '-yield_per_hectare'"
							label="Ertrag"
							:form="form"
							:required="true"
							suffix="t/ha"
							tooltipText="Der erwartete Ertrag des ausgewählten Ernteproduktes pro Hektar."
						></ui-input-group>
					</div>

					<div v-else-if="form.qty__entry_type === 'amount'" class="flex px-6">
						<ui-input-group
							class="basis-full sm:basis-[30.75%] py-4"
							v-model="form.qty__mt"
							field="qty__mt"
							:key="form.qty__entry_type + '-qty__mt'"
							label="Menge"
							:form="form"
							:required="true"
							suffix="t"
							tooltipText="Menge in Tonnen."
						></ui-input-group>
					</div>
				</div>

				<div class="mt-6 px-6">
					<div>
						<h3 class="flex font-semibold text-xl">
							Unverkaufte Menge Ernte {{ form.product__harvest - 1 }}

							<ui-tooltip
								class="flex text-green-400 whitespace-normal"
								:icon-stroke-width="2"
								icon-class="ml-1 w-4 h-4"
								text="Der unverkaufte Lagerbestand, der zum 30.06. eines Erntejahres in die neue Ernte übergeht."
							>
								<ui-icon
									class="sm:mr-2 flex-shrink-0 h-6 w-6 md:h-5 md:w-5"
									name="help-circle"
									stroke-width="2"
								/>
							</ui-tooltip>
						</h3>
					</div>

					<div>
						<span>optional</span>
					</div>
				</div>

				<div class="flex px-6 mb-6">
					<ui-input-group
						class="basis-full sm:basis-[30.75%]"
						v-model="form.qty__remaining"
						field="qty__remaining"
						:form="form"
						:required="true"
						suffix="t"
					></ui-input-group>
				</div>

				<div v-if="userLocations.length > 1">
					<hr class="h-0.5 bg-gray-200 text-gray-200 my-2" />

					<div class="flex p-6 px-6">
						<ui-select-group
							class="basis-full sm:basis-[30.75%] py-4"
							v-model="form.user_location_id"
							field="user_location_id"
							type="select"
							:label="__('userLocation')"
							:options="userLocations"
							:form="form"
							:required="true"
							:placeholder="false"
						></ui-select-group>
					</div>
				</div>

				<div class="bg-gray-100 p-6 px-6">
					<div class="flex justify-end">
						<ui-button
							:disabled="form.processing"
							v-on:click="submitForm()"
							label="Save"
						/>
					</div>
				</div>
			</form>
		</template>
		<!-- devide -->
	</ui-modal-template>
</template>
<script>
import axios from "axios";
import Vue from "vue";
export default {
	props: {
		productTypes: {
			type: Array,
			required: true,
		},
		productGrades: {
			type: Array,
			required: true,
		},
		userLocations: {
			type: Array,
			required: true,
		},
		saleIntention: {
			required: false,
			default: null,
		},
		product__harvest: {
			required: false,
		},
	},
	data() {

		let quantity = null;
		if(this.saleIntention?.qty__mt) {
			quantity = parseFloat(this.saleIntention.qty__mt);
		}

		if(this.saleIntention?.qty__remaining) {
			quantity = (parseFloat(this.saleIntention.qty__mt) - parseFloat(this.saleIntention?.qty__remaining));
		}

		const formData = {
			product__type: this.saleIntention?.product_type_id ?? null,
			product__grade: this.saleIntention?.product_grade_id ?? null,
			product__harvest:
				this.saleIntention?.product__harvest ?? this.product__harvest ?? null,

			qty__entry_type: this.saleIntention?.qty__entry_type ?? 'amount',

			qty__mt: quantity,

			hectare: this.saleIntention?.hectare ?? null,
			yield_per_hectare: this.saleIntention?.yield_per_hectare ?? null,

			qty__remaining: this.saleIntention?.qty__remaining ?? null,

			user_location_id: this.saleIntention?.user_location_id ?? null,
		};

		return {
			form: Vue.observable(this.$inertia.form(formData)),
			errors: {},
		};
	},
	computed: {
		currentProductGradeOptions: function () {
			let currentProductType = this.form.product__type;

			return this.productGrades.filter(function (grade) {
				return currentProductType === grade.product_type_id;
			});
		},
		hasMultipleGrades: function () {
			return (
				this.currentProductGradeOptions &&
				this.currentProductGradeOptions.length > 1
			);
		},
	},
	methods: {
		async submitForm() {
			const params = {};
			if (this.saleIntention) {
				params["id"] = this.saleIntention.id;
			}
			const route = this.$route("sale_intentions.store", params);

			axios.post(route,this.form)
				.then(this.onSuccess)
				.catch(this.onError)
		},
		onSuccess(result) {
			this.$bus.$emit("modal:close");
			this.$bus.$emit("page:content:load");
		},
		onError(error) {

			switch (error.response.status) {
				case 422:
					const errors = error.response.data.errors;
					this.errors = errors;
					this.$bus.$emit("form:invalid", errors);
					break;

				default:
					this.$bus.$emit("modal:error", error);
					break;
			}

		},
		productTypeChanged() {
			this.form.product__grade = null;
		},
		qtyEntryTypeChanged(value){
			this.form.qty__entry_type = value;
		},
	},
};
</script>
